export interface ReceiptQrSettings {
  slug?: string;
  qr_code_msg?: string | null;
  qr_code_url?: string | null;
  qr_code_image?: string | null;
}

export const getHttpUrl = (value: string | null | undefined): string | null => {
  if (!value?.trim() || !/^https?:\/\//i.test(value.trim())) return null;

  try {
    const url = new URL(value.trim());
    return ['http:', 'https:'].includes(url.protocol) && url.hostname ? value.trim() : null;
  } catch {
    return null;
  }
};
